<template>
  <v-card
    max-width="750"
    class="mx-auto"
    :loading="loading"
    :disabled="loading"
  >
    <v-card-title class="indigo darken-3">
      <span class="grey--text text--lighten-4">
        ค้นหา / แก้ไข ข้อมูลผู้สมัคร
      </span>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="5">
          <v-text-field
            outlined
            dense
            small
            label="เลขที่บัตรประชาชน / Passport"
            placeholder="* กรอกแล้วกด enter เพื่อดูข้อมูลเพิ่มเติม"
            v-model="citizen_id"
            @keyup.enter="getUserData"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="1">
          <v-btn
            dense
            elevation="0"
            color="orange lighten-2"
            @click="getUserData"
          >
            ค้นหา
          </v-btn>
        </v-col>
      </v-row>

      <v-card elevation="0" outlined v-if="uid">
        <v-card-text>
          <v-row>
            <v-col>
              <span class="font-weight-bold">UID :</span> {{ uid }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="font-weight-bold">อีเมล</span>
              <v-text-field v-model="email" outlined dense small></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="font-weight-bold">[ไทย] ชื่อ :</span>
              <v-text-field
                v-model="f_name_th"
                outlined
                dense
                small
              ></v-text-field>
            </v-col>
            <v-col>
              <span class="font-weight-bold">[ไทย] นามสกุล :</span>
              <v-text-field
                v-model="l_name_th"
                outlined
                dense
                small
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="font-weight-bold">[Eng] ชื่อ :</span>
              <v-text-field
                v-model="f_name_en"
                outlined
                dense
                small
              ></v-text-field>
            </v-col>
            <v-col>
              <span class="font-weight-bold">[Eng] นามสกุล :</span>
              <v-text-field
                v-model="l_name_en"
                outlined
                dense
                small
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center mt-2">
          <v-btn color="success" class="text-none" large @click="saveUserData">
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import ApplicantInfoProvider from "@/services/applicant_info";

const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "SearchUser",

  data: () => ({
    loading: false,

    citizen_id: null,

    uid: null,
    email: null,
    f_name_th: null,
    l_name_th: null,
    f_name_en: null,
    l_name_en: null,
  }),

  methods: {
    async getUserData() {
      this.loading = true;

      this.uid = null;
      this.email = null;
      this.f_name_th = null;
      this.l_name_th = null;
      this.f_name_en = null;
      this.l_name_en = null;

      const response = await applicantInfoService
        .getUserInfoForOfficer(this.citizen_id)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
      if (response) {
        this.uid = response.UID;
        this.email = response.EMAIL;
        this.f_name_th = response.STUDENT_FNAME_TH;
        this.l_name_th = response.STUDENT_LNAME_TH;
        this.f_name_en = response.STUDENT_FNAME_EN;
        this.l_name_en = response.STUDENT_LNAME_EN;

        this.loading = false;
      }
    },

    async saveUserData() {
      this.loading = true;
      const response = await applicantInfoService
        .setUserInfoForOfficer({
          CITIZEN_ID: this.citizen_id,
          EMAIL: this.email,
          STUDENT_FNAME_TH: this.f_name_th,
          STUDENT_LNAME_TH: this.l_name_th,
          STUDENT_FNAME_EN: this.f_name_en,
          STUDENT_LNAME_EN: this.l_name_en,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
      if (response && response.status) {
        this.$toasted.success(this.$t("toasted.save_successfully"));
      } else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.loading = false;
    },
  },
};
</script>
